import { Popover } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { T, TranslationsContext, translation } from '../../../../../../../Translations';

interface Props {
  onCreateWithoutPublishing: () => void;
  disabled?: boolean;
}

function SaveOptionsDropdown({ onCreateWithoutPublishing, disabled = false }: Props) {
  const ts = useContext(TranslationsContext);

  return (
    <Popover
      trigger="click"
      placement="bottom"
      children={({ onClose }) => (
        <button
          className="w-full text-left px-4 py-2.5 hover:bg-muted transition-colors"
          style={{ fontSize: 'var(--text-sm)' }}
          onClick={() => {
            onClose();
            onCreateWithoutPublishing();
          }}
          data-intercom-target="builder-v2-create-without-publishing-option"
        >
          <T kind="Create without Publishing" />
        </button>
      )}
      renderTrigger={(ref, getReferenceProps) => (
        <button
          ref={ref}
          {...getReferenceProps()}
          className="px-3 py-2.5 bg-accent text-accent-foreground border-l border-accent-foreground/20 rounded-r-md transition-all hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
          disabled={disabled}
          data-intercom-target="builder-v2-save-options-dropdown"
          aria-label={translation('Save options')(ts)}
        >
          <ChevronDownIcon className="w-4 h-4" />
        </button>
      )}
    />
  );
}

export default observer(SaveOptionsDropdown);
